import { Injectable } from '@angular/core';
import { PtrServices } from './ptr-model';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerURLService } from '../common-service/serverURL.service';
import { encryptionService } from '../common-service/cedService';

@Injectable({
  providedIn: 'root'
})
export class  PtrService {

  constructor(public http: HttpServiceService,private url: PtrServices, public serverURL: ServerURLService, public ced: encryptionService) { }

  applicantSignUp(obj){
    return this.http.post(this.url.applicantSignUp,obj);
  }
  SaveRegistation(obj){
    return this.http.post(this.url.registerUser,obj);
  }
  updateRegistration(obj){
    return this.http.post(this.url.updateRegistration,obj);
  }

  updatePaymentDetails(obj){
    return this.http.post(this.url.updatePaymentDetails,obj);
  }

  updateBySecExecutive(obj){
    return this.http.post(this.url.updateBySecExecutive,obj);
  }

  updateBySecHead(obj){
    return this.http.post(this.url.updateBySecHead,obj);
  }

  institutionTypeList(){
    return this.http.get(this.url.institutionTypeList);
  }

  countryList(){
    return this.http.get(this.url.countryList);
  }
  preview(userEmail){
    return this.http.get(this.url.preview+userEmail);
  }
  downloadUploadFIle(filepath){
    return this.http.get(this.url.downloadUploadFIle,filepath);
  }
  
  stateList(){
    return this.http.get(this.url.stateList);
  }
  cityList(){
    return this.http.get(this.url.cityList);
  }
  userDetails(){
    return this.http.get(this.url.getUserDetails);
  }

  userDetailsById(id:any){
    const regIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getUserDetailsById + '?regIdEncr=' + regIdEncr);
  }

  userDetailsByEmail(){
    return this.http.get(this.url.getUserDetailsByEmail);
  }

  userDetailsByCollege(){
    return this.http.get(this.url.getuserDetailsByCollege);
  }

  getApplicationList(){
    const ownerName = encodeURIComponent(this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString());
    return this.http.get(this.url.getApplicationList + '?ownerName=' + ownerName);
  }
 
  getRegDraftDetails(){
    return this.http.get(this.url.getRegDraftDetails);
  }
  saveRegistrationDraft(obj){
    return this.http.post(this.url.saveRegistrationDraft,obj);
  }

  getAcceptanceLetterPdf(id:any){
    const regIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getAcceptanceLetterPdf + '?regIdEncr=' + regIdEncr);
  }

  uploadFile(files:any, regId) {
  /* const h:any={headers: new HttpHeaders({ 
    'Accept': 'application/json', 
   'Access-Control-Allow-Origin':'*'})};*/
   var formdata: FormData = new FormData();
   for (let i = 0; i < files.length; i++) {
    formdata.append('files', files[i]);
  }
    
    return this.http.post<any>(this.url.applicantFileUpload+"?regId="+regId, formdata);
  }

  //Dashboard 
  getAllInstitutionAndCollegePtrApplicationlist(ptrDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getAllInstitutionAndCollegePtrApplicationlist,ptrDashboardSearchCriteria);
  }
  getAllSectionHeadPtrApplicationList(ptrDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getAllSectionHeadPtrApplicationList,ptrDashboardSearchCriteria);
  }
  getAllSectionExecutivePtrApplicationList(ptrDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getAllSectionExecutivePtrApplicationList,ptrDashboardSearchCriteria);
  }
  getAllTrackPtrApplicationList(ptrDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getAllTrackPtrApplicationList,ptrDashboardSearchCriteria);
  }

  getAllPtrStatusList(){
    return this.http.get(this.url.getAllPtrStatusList);
  }

  getPtrProcessHistory(id:any){
    const regIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getPtrProcessHistory + '?regIdEncr=' + regIdEncr);
  }
  ptrApplicationSeekApprovalReturnForCorrection(obj: any) {
    return this.http.post(this.url.ptrApplicationSeekApprovalReturnForCorrection, obj);
  }

  ptrApplicationReSubmit(obj: any) {
    return this.http.post(this.url.ptrApplicationReSubmit, obj);
  }

  updatePtrApplicationWorkflow(obj: any) {
    return this.http.post(this.url.updatePtrApplicationWorkflow, obj);
  }

  getPtrApplicationViewExportPdf(registrationId: any) {
    const obj = {
      registrationId: this.ced.encryptAesToString(registrationId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getPtrApplicationViewExportPdf, obj);
  }

}
